import { Outlet } from "react-router-dom";
import Directory from "../../components/directory/directory.component";
import AboutUs from "../../components/about-us/about-us.component";


const Home = () => {
  return (
    <div >
      <AboutUs />
      <Directory />
      <Outlet />
    </div>
  );
};

export default Home;
